import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=1e6cbcce&scoped=true&"
import script from "./addForm.vue?vue&type=script&lang=js&"
export * from "./addForm.vue?vue&type=script&lang=js&"
import style0 from "./addForm.vue?vue&type=style&index=0&id=1e6cbcce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6cbcce",
  null
  
)

export default component.exports